let dataFuncionario = {};

const toSessionElements = document.getElementsByClassName("data-fu-accion");
if (toSessionElements.length > 0) {
    for (let elemento of toSessionElements) {
        elemento.addEventListener("click", function (event) {
            const tramiteId = this.getAttribute("data-fu-tramite");
            const tipo = this.getAttribute("data-ga-cat");

            if (tramiteId in dataFuncionario) {
                const elemento_funcionario = elemento
                    .closest(".accordion-item")
                    .querySelector(".sesion-funcionario");
                elemento_funcionario.innerHTML = dataFuncionario[tramiteId];
                clickEnlacesRegistro();
            } else {
                fetch(`/tramite-funcionario/${tramiteId}?tipo=${tipo}`, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then(function (data) {
                        if (data.funcionario) {
                            dataFuncionario[tramiteId] = data.data;
                            const elemento_funcionario = elemento
                                .closest(".accordion-item")
                                .querySelector(".sesion-funcionario");
                            elemento_funcionario.innerHTML = data.data;
                            clickEnlacesRegistro();
                        }
                    });
            }
        });
    }
}

clickEnlacesRegistro();

function clickEnlacesRegistro() {
    const enlacesRegistro = document.getElementsByClassName("enlace-registro");
    if (enlacesRegistro.length > 0) {
        for (let elemento of enlacesRegistro) {
            elemento.addEventListener("click", function (event) {
                event.preventDefault();

                const btn = this;

                if (this.classList.contains("bloquear")) return false;

                btn.classList.add("bloquear");
                const src = btn.getAttribute("href");
                const linkToken = document.getElementById("link-token");

                var data = new FormData();
                var token = document.head.querySelector(
                    'meta[name="csrf-token"]'
                );
                var usuario_id = linkToken.getAttribute("data-user");
                var url_base = linkToken.getAttribute("data-baseurl");

                data.append("_token", token.content);
                data.append("user_core_id", usuario_id);

                fetch(url_base + "/obtener-token-acceso-personal", {
                    method: "POST",
                    body: data,
                    redirect: "follow",
                })
                    .then((response) => response.json())
                    .then(function (data) {
                        if (data.mensaje == "success") {
                            linkToken.setAttribute(
                                "href",
                                src +
                                    "?tokenpersonal=" +
                                    data.token +
                                    "&usuario=" +
                                    usuario_id
                            );
                            linkToken.click();

                            btn.classList.remove("bloquear");
                        }
                    });
            });
        }
    }
}

setEliminarTramite = function (e) {
    let data = e.dataset;
    document.getElementById("tramite_eliminar_id").value = data.id;
    document.getElementById("categoria_eliminar").value = data.categoria;
};

initEliminarTramite = function () {
    let e = document.getElementById("btn_eliminar_tramite");
    e.innerHTML = `<i class="fas fa-spinner fa-spin"></i> Eliminando...`;
    e.disabled = true;
};
